<template>
  <div class="size-full [contain:strict]">
    <div
      class="go-scrollbar flex h-full flex-col items-start justify-start gap-2 self-stretch overflow-auto"
    >
      <slot />
    </div>
  </div>
</template>
